import styled from "styled-components";

export const ModalOverlay = styled.div`
  position: fixed;

  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;

  inset: 0;

  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3);
`;

export const ModalBox = styled.div`
  position: relative;
  min-width: fit-content;
  max-width: 80vw;
  max-height: 90vh;
  overflow-y: auto;
  background: #fff;
  border-radius: 0.5rem;
`;

// `button`, não `div`: como div não recebia foco nem respondia a teclado, e o `isWhite` que ela
// declarava não era usado em nenhuma regra — só vazava para o DOM como atributo, gerando aviso do
// React a cada render de modal.
export const CloseButton = styled.button`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  width: 35px;
  height: 35px;
  z-index: 100000;
  color: black;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  flex-shrink: 0; /* Prevents button from shrinking */

  &:hover {
    background: rgba(0, 0, 0, 0.1);
  }

  img,
  svg {
    width: 20px;
    height: 20px;
    display: block;
    color: #555;
  }
`;
